<script>
  import { router } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import FilterBar from '../../components/filter_bar.svelte'
  import EntityList from '../../components/entity/entity_list.svelte'
  import DisplayOptions from '../../components/entity/display_options.svelte'
  import Paginator from '../../components/paginator.svelte'
  import FilterTabs from '../../components/filter_tabs.svelte'
  import SearchInput from '../../components/search_input.svelte'
  import FilterSelect from '../../components/filter_select.svelte'
  import { Button } from '../../components/ui'
  import { confirm } from '../../components/confirm.js'

  let {
    users = [],
    pagy = { page: 1, pages: 1, count: 0 },
    total_count = null,
    mode = 'all',
    filters = {},
    report_reason_options = []
  } = $props()

  const SORT_OPTIONS = [
    { value: 'newest', label: 'Newest first' },
    { value: 'oldest', label: 'Oldest first' },
    { value: 'most_reported', label: 'Most reported' }
  ]

  let searchValue = $state(filters.search || '')
  let viewMode = $state(null)

  const applyFilters = (changes) => {
    router.get(
      '/user-icons',
      { mode, search: filters.search, report_reason: filters.report_reason, sort: filters.sort, ...changes },
      { preserveState: true, preserveScroll: true }
    )
  }

  const approve = (user) => {
    router.patch(`/user-icons/${user.id}/review`, { review_action: 'approve' }, { preserveScroll: true })
  }

  const clearIcon = async (user) => {
    const confirmed = await confirm({
      title: 'Clear User Icon',
      variant: 'error',
      body: "This will remove the user's profile icon and dismiss all reports. Are you sure?",
      confirmLabel: 'Clear Icon'
    })
    if (!confirmed) return
    router.patch(`/user-icons/${user.id}/review`, { review_action: 'clear_icon' }, { preserveScroll: true })
  }
</script>

<Layout>
  <PageHeader title="Profiles" subtitle="Review member profile icons" count={pagy.count} total={total_count} />

  <FilterBar>
    {#snippet start()}
      <FilterTabs
        tabs={[{ key: 'all', label: 'All Icons' }, { key: 'flagged', label: 'Flagged' }]}
        active={mode}
        param="mode"
      />
    {/snippet}
    {#snippet end()}
      <DisplayOptions entity="user_icon" bind:viewMode />
    {/snippet}
  </FilterBar>

  <FilterBar>
    {#snippet start()}
      <SearchInput bind:value={searchValue} placeholder="Search users…" />
      <FilterSelect
        label="Report Reason"
        value={filters.report_reason || ''}
        placeholder="Any"
        options={report_reason_options}
        onchange={(v) => applyFilters({ report_reason: v || undefined })}
      />
      <FilterSelect
        label="Sort"
        value={filters.sort}
        placeholder={null}
        options={SORT_OPTIONS}
        onchange={(v) => applyFilters({ sort: v })}
      />
    {/snippet}
  </FilterBar>

  <EntityList
    entity="user_icon"
    rows={users}
    {viewMode}
    emptyMessage={mode === 'flagged' ? 'No flagged users to review.' : 'No users with profile icons found.'}
  >
    {#snippet actions(user)}
      <Button variant="ghost" size="sm" square icon="check" class="text-success" title="Dismiss Reports" aria-label="Dismiss Reports" onclick={() => approve(user)} />
      <Button variant="ghost" size="sm" square icon="close" class="text-error" title="Clear Icon" aria-label="Clear Icon" onclick={() => clearIcon(user)} />
    {/snippet}
  </EntityList>

  <Paginator {...pagy} />
</Layout>
